export default __webpack_public_path__ + "static/media/November2020.f58c379a.png";